import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './InsufficientBalanceError.css';

interface InsufficientBalanceErrorProps {
  balance: number;
  requiredBalance: number;
}

const InsufficientBalanceError: React.FC<InsufficientBalanceErrorProps> = ({
  balance,
  requiredBalance
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation('create');
  
  return (
    <div className="insufficient-balance-container">
      <div className="insufficient-balance-card">
        <div className="error-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#FF5252" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 8V12" stroke="#FF5252" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 16H12.01" stroke="#FF5252" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        
        <h2>{t('insufficient_balance.title')}</h2>

        <div className="balance-info">
          <div className="balance-item">
            <span className="balance-label">{t('insufficient_balance.current_balance')}</span>
            <span className="balance-value">{balance} {t('insufficient_balance.balance_unit')}</span>
          </div>
          <div className="balance-item">
            <span className="balance-label">{t('insufficient_balance.required')}</span>
            <span className="balance-value">{requiredBalance} {t('insufficient_balance.balance_unit')}</span>
          </div>
          <div className="balance-item">
            <span className="balance-label">{t('insufficient_balance.shortfall')}</span>
            <span className="balance-value negative">{requiredBalance - balance} {t('insufficient_balance.balance_unit')}</span>
          </div>
        </div>

        <p className="error-description">
          {t('insufficient_balance.description_detail')}
        </p>

        <div className="action-buttons">
          <button
            className="primary-button"
            onClick={() => navigate('/payment')}
          >
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 8V16" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M8 12H16" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            {t('insufficient_balance.top_up_button')}
          </button>
          <button
            className="secondary-button"
            onClick={() => navigate('/reports')}
          >
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 12H5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 19L5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            {t('insufficient_balance.back_to_reports')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InsufficientBalanceError;
